import * as React from "react"
import type { SVGProps } from "react"
const SvgDeviceTablet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 23.57q-.82 0-1.41-.59A2 2 0 0 1 3 21.57v-18q0-.82.59-1.41A2 2 0 0 1 5 1.57h14q.83 0 1.41.59.6.59.59 1.41v18q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm0-3v1h14v-1zm0-2h14v-12H5zm0-14h14v-1H5z" />
  </svg>
)
export default SvgDeviceTablet
